// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ddbdb3df","453":"4d96cf20","455":"0952d62a","977":"fc40a555"}[chunkId] + ".chunk.js";
};